import { UIComponentProps, UIComponentHandler, UIComponentImpl, UIComponentState, UIDataModel } from '../../../toolkit/uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { MyProfileDetailsViewImpl } from './myprofiledetailsview';
import { MyProfileDetailsCSSStyleImpl } from './myprofiledetailscss';


export interface MyProfileDetailsComponentProps extends UIComponentProps
{
   profileName:string;
   contactNumber:string;
   status:string;
   subscriber(): void;
   unSubscriber(): void;
   onRewardPointClick(): void;
}

export interface MyProfileDetailsComponentHandler extends UIComponentHandler
{

}
export interface MyProfileDetailsComponentState extends UIComponentState
{
   
    userStatus: any;
}

export class MyProfileDetailsComponent extends UIComponentImpl<MyProfileDetailsComponentProps, MyProfileDetailsComponentState, UIDataModel>
{
    constructor(props: MyProfileDetailsComponentProps)
    {
        super(props);
        this.state = {userStatus: props.status};

       
    }

    componentDidMount()
    {
        
    }
    componentWillReceiveProps(nextProps: MyProfileDetailsComponentProps)
    {
      
        this.setState({userStatus:nextProps.status});
    }
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new MyProfileDetailsViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new MyProfileDetailsCSSStyleImpl(applicationContext);
    }

    

}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/myaccount/myprofiledetails/myprofiledetailscomponent.tsx